import { UtilityService } from "./index";

class EmployeeSampleServices {

  async employees(page) {
    let result = await fetch(
      UtilityService.baseUrl() + "api/customer/employeesamplerequest",
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          AuthToken: localStorage.getItem("authToken")
        },
        body: JSON.stringify({
          page: page
        })
      }
    );
    return {
      status: result.status,
      text: await result.json()
    };
  }

  async newsampleemployeesearch(moduleName, name) {
    let result = await fetch(
      UtilityService.baseUrl() + "api/customer/employeesamplerequest",
      {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          AuthToken: localStorage.getItem("authToken")
        },
        body: JSON.stringify({
          search:name
        })
      }
    );
    return {
      status: result.status,
      text: await result.json()
    };
  }


  async newEmployee(id) {
    let result = await fetch(UtilityService.baseUrl() + `api/customer/employeesamplerequest?employeeId=${id}`, {
      method: "POST",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'AuthToken': localStorage.getItem("authToken")
      }
    });

    return {
      status: result.status,
      text: await result.json()
    }
  }

  async newEmployeeListTable(id) {
    let result = await fetch(UtilityService.baseUrl() + `api/customer/employee/${id}`, {
      method: "POST",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'AuthToken': localStorage.getItem("authToken")
      }
    });

    return {
      status: result.status,
      text: await result.json()
    }
  }

  async newEmployeeScrollListTable(id, page) {
    let result = await fetch(UtilityService.baseUrl() + `api/customer/employee/${id}`, {
      method: "POST",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'AuthToken': localStorage.getItem("authToken")
      },
      body: JSON.stringify({
        page: page
      })
    });

    return {
      status: result.status,
      text: await result.json()
    }
  }

  async newEmployeeStatusTable(id, status) {
    let result = await fetch(UtilityService.baseUrl() + `api/customer/employee/${id}?statusType=${status}`, {
      method: "POST",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'AuthToken': localStorage.getItem("authToken")
      }
    });

    return {
      status: result.status,
      text: await result.json()
    }
  }

  async newEmployeeListStatusTable(id, status, page) {
    let result = await fetch(UtilityService.baseUrl() + `api/customer/employee/${id}?statusType=${status}`, {
      method: "POST",
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'AuthToken': localStorage.getItem("authToken")
      },
      body: JSON.stringify({
        page: page
      })
    });

    return {
      status: result.status,
      text: await result.json()
    }
  }


}
export default new EmployeeSampleServices();



// WEBPACK FOOTER //
// ./src/services/employeesample.service.js